import { Injectable } from '@angular/core'
import { IModelBase } from 'common-components'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface IPhoneNumber extends IModelBase {
  Number: string
  PhoneTypeId: number
  CreatedByIdentity: string
  CreatedOnDateTime: Date
  LastModifiedByIdentity: string
  LastModifiedOnDateTime: Date
}

@Injectable()
export class PhoneNumberODataService extends ODataService<IPhoneNumber> {
  constructor(
    protected http: HttpClient,
    protected config: SmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'PhoneNumbers'
  }
}
